export default __webpack_public_path__ + "static/media/formImg.95fc973b.svg";